<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-horizontal",
    {
      scopedSlots: _vm._u([
        {
          key: "navbar",
          fn: function (ref) {
            var toggleVerticalMenuActive = ref.toggleVerticalMenuActive
            return [
              _c("app-navbar-horizontal-layout-brand"),
              _c("navbar", {
                attrs: {
                  "toggle-vertical-menu-active": toggleVerticalMenuActive,
                },
              }),
            ]
          },
        },
      ]),
    },
    [_c("router-view")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/horizontal/LayoutHorizontal.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import core_layouts_layout_horizontal_LayoutHorizontal_vue from '@core/layouts/layout-horizontal/LayoutHorizontal.vue';
import core_layouts_components_app_navbar_AppNavbarHorizontalLayoutBrand_vue from '@core/layouts/components/app-navbar/AppNavbarHorizontalLayoutBrand.vue';
import components_Navbar_vue from '../components/Navbar.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'


export default ({
  render,
  staticRenderFns,
  components: {
    LayoutHorizontal: core_layouts_layout_horizontal_LayoutHorizontal_vue,
    // AppCustomizer,
    Navbar: components_Navbar_vue,
    AppNavbarHorizontalLayoutBrand: core_layouts_components_app_navbar_AppNavbarHorizontalLayoutBrand_vue
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    };
  }
});

//# sourceURL=webpack:///./src/layouts/horizontal/LayoutHorizontal.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

